import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngx-task-list-modal',
  templateUrl: './task-list-modal.component.html',
  styleUrls: ['./task-list-modal.component.scss'],
})
export class TaskListModalComponent implements OnInit {
  purchaseOrder;
  checklist;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  checklistChanged($event) {
    this.checklist = $event;
  }

}
